"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.trim = function (str, char) {
  return str.replace(new RegExp("^[" + char + "]+|[" + char + "]+$", "g"), "");
};